import { useTranslation } from "react-i18next";
import ErrorMessage from "../errorMessage/ErrorMessage";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";

const Page404 = () => {
  const {
    t: t
  } = useTranslation();

  return (
    (<div className="w3-display-container content-container ">
      <div className="w3-display-middle form-display">
        <div className="w3-panel record-panel">
          <div className="w3-container w3-center w3-padding-small">
            <ErrorMessage message={t("page_does_not_exist")} />
            <div className="w3-btn w3-round-xlarge w3-theme-d5">
              <NavLink to={`/`} className="home-label">
                <FontAwesomeIcon icon={faLeftLong} />{t("to_main_page")}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>)
  );
};
export default Page404;
